import { isUpcomingSummaryPdfProduct } from "@/lib/summary-pdf-sales";
import { PDF_PRODUCTS } from "@/constants/pdf-products";
import { passTypeForProductId } from "@/types/pass";

/** PDF가 사은품으로 포함된 이용권도 일반결제 상품이다. */
export function getTossProductProfile(productId: string) {
  const isCulturalExpenses = isUpcomingSummaryPdfProduct(productId) || PDF_PRODUCTS.some((product) => product.id === productId);
  if (!isCulturalExpenses && !passTypeForProductId(productId)) {
    throw new Error("지원하지 않는 결제 상품입니다.");
  }
  const merchantId = isCulturalExpenses ? "ejeongkipm" : "ejeonghebs";
  const isTest = process.env.NEXT_PUBLIC_TOSS_CLIENT_KEY?.startsWith("test_") === true;
  return {
    merchantId: isTest ? `t${merchantId}` : merchantId,
    isCulturalExpenses,
    paymentDarkVariantKey: (isCulturalExpenses
      ? process.env.NEXT_PUBLIC_TOSS_PDF_DARK_VARIANT_KEY
      : process.env.NEXT_PUBLIC_TOSS_PASS_DARK_VARIANT_KEY)?.trim() || undefined,
    paymentVariantKey: (isCulturalExpenses
      ? process.env.NEXT_PUBLIC_TOSS_PDF_VARIANT_KEY
      : process.env.NEXT_PUBLIC_TOSS_PASS_VARIANT_KEY)?.trim() || "",
  };
}

export function isTossProductProfileConfigured(profile: ReturnType<typeof getTossProductProfile>) {
  const pdf = [process.env.NEXT_PUBLIC_TOSS_PDF_VARIANT_KEY, process.env.NEXT_PUBLIC_TOSS_PDF_DARK_VARIANT_KEY].map(key => key?.trim()).filter(Boolean);
  const pass = [process.env.NEXT_PUBLIC_TOSS_PASS_VARIANT_KEY, process.env.NEXT_PUBLIC_TOSS_PASS_DARK_VARIANT_KEY].map(key => key?.trim()).filter(Boolean);
  // 기본 UI로의 묵시적 복귀와 두 상품군의 동일 UI 연결을 금지한다.
  return Boolean(profile.paymentVariantKey && !pdf.some(key => pass.includes(key)));
}
